import "./nominas.scss";
import React, { useEffect, useState } from "react";
import TituloCard from "../../atoms/titles/Titulo";
import Button from "../../atoms/buttons/Button";
import {
  aumentarCuadre,
  disminuirCuadre,
  getCuadre,
} from "../../services/NominasService";
import { getDateFromStringToObj } from "../../../utils/Utils";
import { SpinnerCircleMini } from "../../atoms/spinner/Spinner";

const Nominas = (object) => {
  const [dispo, setDispo] = useState("");
  const [loading, setLoading] = useState(false);
  const meses = [
    "",
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];
  useEffect(() => {
    getCuadre().then((data) => {
      
      // 
      setDispo(getDateFromStringToObj(data));
      setLoading(true);
    });
  }, []);
  return (
    <>
      <TituloCard tipo="tituloModal" titulo={<h2 className="tituloPagina4">Nóminas</h2>} />
      <TituloCard
        tipo="tituloPagina2 noBg"
        titulo={<h3 className="tituloPagina4">Visualización de la Nómina</h3>}
      />

      {loading ? (
        <div className="fw-bold">{`${meses[parseInt(dispo.mes)]} del ${
          dispo.anio
        }`}</div>
      ) : (
        <SpinnerCircleMini></SpinnerCircleMini>
      )}
      <div className="div d-flex">
        <Button
          id="btnAumentar"
          clases="btn-card mt-3"
          nombre={
            <>
              <i className="fa-solid fa-angles-up"> </i>{" "}
              <span className="text-light">Aumentar</span>
            </>
          }
          tipo="button"
          funcion={() => {
            aumentarCuadre().then((data) => {
              setLoading(false);
              
              getCuadre().then((data) => {
                
                setDispo(getDateFromStringToObj(data));
                setLoading(true);
              });
            });
          }}
        ></Button>
        <Button
          id="btnDisminuir"
          clases="btn-card mt-3"
          nombre={
            <>
              <i className="fa-solid fa-angles-down"> </i>{" "}
              <span className="text-light">Disminuir</span>
            </>
          }
          tipo="button"
          funcion={() => {
            disminuirCuadre().then((data) => {
              setLoading(false);
              
              getCuadre().then((data) => {
                
                setDispo(getDateFromStringToObj(data));
                setLoading(true);
              });
            });
          }}
        ></Button>
      </div>
    </>
  );
};
export default Nominas;
